export default {"src":"/_next/static/media/antigua-and-barbuda.e0010409.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};